/* eslint-disable */
import { AUTH0_PREFIX, cacheKey } from 'appConstants';

function exceptionDecorator(func) {
	return function(data, value) {
		try {
			return func.call(this, data, value);
		} catch (err) {
			if (err.name === 'SecurityError') {
				this._securityError = true;
			}
			return null;
		}
	};
}

class LocalStorage {
	constructor() {
		this.getItem = exceptionDecorator(this.getItem);
		this.setItem = exceptionDecorator(this.setItem);
		this.setItems = exceptionDecorator(this.setItems);
		this.removeItem = exceptionDecorator(this.removeItem);
		this.removeItems = exceptionDecorator(this.removeItems);
		this.clear = exceptionDecorator(this.clear);
		this.getAuth0Cache = exceptionDecorator(this.getAuth0Cache);
		this._securityError = false;
	}

	getItem(key) {
		const extData = JSON.parse(localStorage.getItem('ext')) || {};
		const data = extData[key];
		try {
			return JSON.parse(data);
		} catch {
			return data;
		}
	}

	setItem(key, value) {
		const extData = JSON.parse(localStorage.getItem('ext')) || {};
		extData[key] = value;
		localStorage.setItem('ext', JSON.stringify(extData));
	}

	setItems(obj) {
		const extData = JSON.parse(localStorage.getItem('ext')) || {};
		for (const k in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, k)) {
				extData[k] = obj[k];
			}
		}
		localStorage.setItem('ext', JSON.stringify(extData));
	}

	removeItem(key) {
		const extData = JSON.parse(localStorage.getItem('ext'));
		if (extData) {
			delete extData[key];
			localStorage.setItem('ext', JSON.stringify(extData));
		}
	}

	removeItems(keys) {
		const extData = JSON.parse(localStorage.getItem('ext'));
		if (extData) {
			keys.forEach((k) => delete extData[k]);
		}
		localStorage.setItem('ext', JSON.stringify(extData));
	}

	clear() {
		const extData = JSON.parse(localStorage.getItem('ext'));
		if (extData) {
			localStorage.setItem(
				'ext',
				JSON.stringify({
					[cacheKey.SEND_METHOD]: extData[cacheKey.SEND_METHOD] || 'enter'
				})
			);
		}
		// Remove auth0 data
		const auth0Key = Object.keys(localStorage).find((item) => item.includes(AUTH0_PREFIX));
		localStorage.removeItem(auth0Key);
	}

	getAuth0Cache() {
		const auth0Key = Object.keys(localStorage).find((item) => item.includes(AUTH0_PREFIX));
		return JSON.parse(localStorage[auth0Key]);
	}

	set username(username) {
		this._userame = username;
	}

	get username() {
		return this._username;
	}

	set accountId(accountId) {
		this._accountId = accountId;
	}

	get accountId() {
		return this._accountId;
	}

	set auth0(flag = false) {
		this.auth0Flag = flag;
	}

	get auth0() {
		return this.auth0Flag;
	}

	set onLogin(flag) {
		this.onLoginFlag = flag;
	}

	get onLogin() {
		return this.onLoginFlag;
	}

	set realTimeTicket(ticket) {
		this.ticket = ticket;
	}

	get realTimeTicket() {
		return this.ticket;
	}
}

export const extLocalStore = new LocalStorage();
